import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/css/Introduce.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { MARK_AS_LOGIN, UPDATE_PROFILE } from "../../redux/actions/types";
import config from "../../config";

const Introduce = ({ auth, updateProfile, markAsLogin }) => {
    const navigate = useNavigate();
    const [bio, setBio] = useState("");
    useEffect(() => {
        if (auth.user && auth.token) {
            if (auth.user.bio) {
                navigate("/");
            }
        } else {
            navigate("/signin");
        }
    }, []);

    const updateBio = async (e) => {
        e.preventDefault();
        const res = await config.postApi(
            config.services.updateProfile(),
            config.bearerHeaders(auth.token),
            JSON.stringify({ bio })
        );
        if (res) {
            updateProfile(res.response.data);
            markAsLogin();
            navigate("/");
        }
    };

    return (
        <>
            <Header />
            {/* <!-- Introduce Yourself Sec Start Here --> */}
            <section className="introduce">
                <div className="container">
                    <div className="row">
                        <div className="col-md-3"></div>
                        <div className="col-md-6">
                            <div className="introduce_box">
                                <div className="heading_wrapper">
                                    <h4>Introduce Yourself</h4>
                                    <p>
                                        Let other know about you, we will show
                                        these words in your profile
                                    </p>
                                </div>
                                <form onSubmit={updateBio}>
                                    <label htmlFor="yourself">
                                        Your Introduction{" "}
                                        <span className="light">
                                            (300-500 Words)
                                        </span>
                                    </label>
                                    <textarea
                                        id="yourself"
                                        maxLength="500"
                                        className="form-control"
                                        placeholder="Write about yourself"
                                        value={bio}
                                        onChange={(e) => setBio(e.target.value)}
                                    />
                                    <button className="buttons" type="submit">
                                        Next
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="col-md-3"></div>
                    </div>
                </div>
            </section>
            {/* <!-- Introduce Yourself Sec End Here --> */}

            {/* <!-- Brands Div Start Here --> */}
            <section className="brandsDv">
                <div className="container">
                    <hr />
                    <div className="row">
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src="img/client-logo-1.png" alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src="img/client-logo-2.png" alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src="img/client-logo-3.png" alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src="img/client-logo-4.png" alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src="img/client-logo-5.png" alt="" />
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-4">
                            <div className="brand_img">
                                <figure>
                                    <img src="img/client-logo-6.png" alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                    {/* <hr /> */}
                </div>
            </section>
            <Footer />
            {/* <!-- Brands Div End Here --> */}
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    updateProfile: (user) => dispatch({ type: UPDATE_PROFILE, payload: user }),
    markAsLogin: () => dispatch({ type: MARK_AS_LOGIN }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Introduce);
